module.exports = __webpack_public_path__ + "static/1301815523.dcd8afe5.jpg";